var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"show-submenu"}},[_c('ul',{staticClass:"uc-menu-sub uc-menu-sub-area sub-menu",class:{'select': _vm.isShow}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }